import React from 'react'

const Success = ({ message, data }) => {
	return (
		<div className='flex flex-col p-10 w-full text-center text-xl '>
			<div>{message}</div>
			{/* <div>{JSON.stringify(data)}</div> */}
			{message === 'Data successfully sent to google sheets' ? (
				<div>Add another file or close this window.</div>
			) : (
				<div>Please wait...</div>
			)}
		</div>
	)
}

export default Success
